import React from "react"

export default function PositivityFeedbackCell(props) {

  return (
    <div className={`feedbackCell ${props.extraClasses}`} style={props.feedbackStyle}>
      <div className="feedbackText">{props.feedbackText}</div>
        {
            props.callTaker ? (
                <p className="feedbackAuthor">{props.callTaker}</p>
            ) : null
        }
    </div>
  )
}
